import Button from "@Components/Button";
import styles from "./PartnerReferWhitelabelSection.module.scss";
import HomeTickIcon from "@Icons/HomeTickIcon";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import { BASE_IMG_URL } from "constants/configConstants";
import PartnerLeadFormModal from "@Components/PartnerLeadFormModal";
import LeadFormDispatcher from "@Components/PartnerLeadFormModal/actions";
import { useDispatch } from "react-redux";
import wrapperHOC from "@Utils/wrapperHOC";
import ScholarshipBanner from "../ScholarshipBanner";
import useWhitelabel from "hooks/useWhitelabel";
import useTranslationHook from "hooks/useTranslationHook";

interface PartnerReferWhitelabelSectionProps {
  isDesktop?: boolean;
  data: any;
}

const PartnerReferWhitelabelSection: React.FC<PartnerReferWhitelabelSectionProps> = ({
  isDesktop = false,
  data,
}) => {
  const dispatch = useDispatch();
  const { isWhitelabel, isUSAPartner } = useWhitelabel();
  const { t } = useTranslationHook();

  const handleEnquire = () => {
    const leadFormDispatcher = new LeadFormDispatcher(dispatch);
    leadFormDispatcher.handleOnEnquireClick({
      data: {},
      source: "partner_enquire",
      page: 1,
    });
  };

  return data.id ? (
    <div className={formatClassNames(styles.sectionReferredContainer, isDesktop && styles.desktop)}>
      <div
        className={formatClassNames(styles.sectionInnerContainer, isDesktop && styles.desktop)}
        style={{ backgroundImage: `url("${BASE_IMG_URL}home-partners-refer-banner.svg")` }}
      >
        <div className={styles.sections}>
          <HomeTickIcon tickFill="#e26575" homeFill="#ec919c" />

          <div className={styles.textWrapper}>
            <div className={styles.bannerTitle}>
              {t(
                isWhitelabel && isUSAPartner
                  ? "whitelabel.home.referralbox.title.usa"
                  : "whitelabel.home.referralbox.title",
              )}
            </div>
            <div className={styles.bannerSubtitle}>{t("whitelabel.home.referralbox.subtitle")}</div>
          </div>
        </div>
        <Button
          variant="none"
          size="medium"
          type="button"
          onClick={handleEnquire}
          className={styles.assistanceButton}
        >
          {t(
            isWhitelabel && isUSAPartner
              ? "whitelabel.home.referralbox.cta.usa"
              : "whitelabel.home.referralbox.cta",
          )}
        </Button>
      </div>
      <PartnerLeadFormModal partnerData={data && data} />
      <ScholarshipBanner isMobile={!isDesktop} />
    </div>
  ) : (
    <></>
  );
};

export default wrapperHOC(PartnerReferWhitelabelSection, {
  componentName: "PartnerReferWhitelabelSection-Home",
  showForChina: true,
});
